/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResetPasswordWithToken
 */
export interface ResetPasswordWithToken {
  /**
   *
   * @type {string}
   * @memberof ResetPasswordWithToken
   */
  token: string;
  /**
   *
   * @type {string}
   * @memberof ResetPasswordWithToken
   */
  newPassword: string;
}

export function ResetPasswordWithTokenFromJSON(
  json: any
): ResetPasswordWithToken {
  return ResetPasswordWithTokenFromJSONTyped(json, false);
}

export function ResetPasswordWithTokenFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResetPasswordWithToken {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    token: json['token'],
    newPassword: json['new_password'],
  };
}

export function ResetPasswordWithTokenToJSON(
  value?: ResetPasswordWithToken | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    token: value.token,
    new_password: value.newPassword,
  };
}
